import { useEffect, useState } from 'react';
import DashboardLayout from 'components/app/DashboardLayout'
import axios from 'utils/axios'
import 'react-loading-skeleton/dist/skeleton.css'
import { useAuth } from 'hooks/auth'
import CountUp from 'react-countup'
import { API_ENDPOINTS } from 'utils/api-endpoints';

const StatCard = ({ title, total, status }) => {
  return (
    <div className="flex flex-col justify-between p-8 w-full h-auto bg-white shadow-lg mr-2">
      <div className="flex flex-row justify-between">
        <div className="borders">
          {status?.toLowerCase() === "pending" &&
            <div className="flex items-center justify-center inline-block w-12 h-12 text-center rounded-lg text-yellow-700 bg-yellow-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
              </svg>
            </div>
          }
          {status?.toLowerCase() === "accepted" &&
            <div className="flex items-center justify-center inline-block w-12 h-12 text-center rounded-lg text-green-700 bg-green-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
          }
          {status?.toLowerCase() === "refused" && <div className="flex items-center justify-center inline-block w-12 h-12 text-center rounded-lg text-pink-700 bg-pink-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>}
        </div>
        <div><h1 className="text-2xl font-bold text-gray-500"><CountUp end={total} /> </h1></div>
      </div>
      <h2 className="text-gray-800 text-md font-semibold pt-4"> {title} </h2>
    </div>
  )
}

function Dashboard() {

  // User infos
  const [stats, setStats] = useState([]);

  const { user } = useAuth();

  useEffect(() => {

    async function getStats() {
      const response = await axios.get(API_ENDPOINTS.STATISTIC_COMPOSER)
      return response.data.data;
    }

    getStats().then((res) => {
      setStats(res)
    })

    return () => {
      setStats([]);
    }

  }, [user]);

  return (
    <DashboardLayout>
      <div className="flex flex-col space-y-6 h-screen">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-pgray">
            My Dashboard
          </h2>
        </div>

        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 w-full">
          <StatCard title={'Pending Works'} total={stats.pendingOeuvre} status={'pending'} />
          <StatCard title={'Validated Works'} total={stats.acceptedOeuvre} status={'accepted'} />
          <StatCard title={'Refused Works'} total={stats.refusedOeuvre} status={'refused'} />
        </div>
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 w-full">
          <StatCard title={'Pending Composers'} total={stats.pendingComposer} status={'pending'} />
          <StatCard title={'Validated Composers'} total={stats.acceptedComposer} status={'accepted'} />
          <StatCard title={'Refused Composers'} total={stats.refusedComposer} status={'refused'} />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Dashboard;
